import request from "../api/agent";

const API_ROUTE = "edi_monitor/v1/edi/files";

export class EdiMonitorService {

  async getEdiFilesMonitor(page, limit, file_name = '', zip_file_name = '', client = '', file_type = '', arrival_time = '', created_date = '', partners = '') {
    const params = `?page=${page}&limit=${limit}&file_name=${file_name}&zip_file_name=${zip_file_name}&client=${client}&file_type=${file_type}&arrival_time=${arrival_time}&created_date=${created_date}&partners=${partners}`;

    const response = await request.get(`${API_ROUTE}/monitor` + params);
    return response.data ?? response?.response?.data;
  }

  async downloadEdiFilesReport(page, limit, file_name = '', zip_file_name = '', client = '', file_type = '', arrival_time = '', created_date = '', partners = '') {
    const params = `?page=${page}&limit=${limit}&file_name=${file_name}&zip_file_name=${zip_file_name}&client=${client}&file_type=${file_type}&arrival_time=${arrival_time}&created_date=${created_date}&partners=${partners}`;

    const response = await request.get(`${API_ROUTE}/monitor-download` + params);
    return response.data;
  }

  async exportEdiFilesReport(
    file_name = '',
    zip_file_name = '',
    client = '',
    file_type = '',
    arrival_time = '',
    created_date = '',
    partners = ''
  ) {
    const payload = {
      file_name,
      zip_file_name,
      client,
      file_type,
      arrival_time,
      created_date,
      partners
    };

    const response = await request.post(
      'edi_monitor/v1/export-report',
      payload,
    );

    return response?.data;
  }
}
